<template>
  <v-data-table
    :headers="headers"
    :items="filteredProsthesisTypes"
    sort-by="name"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-text-field
          label="Busca"
          v-model="filter"
          outlined
          dense
          hide-details
          clearable
          append-icon="eva-search-outline"
        />

        <v-spacer></v-spacer>

        <v-dialog v-model="dialog" max-width="500px" @click:outside="close">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
              Novo modelo
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container fluid>
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      v-model="editedItem.name"
                      label="Nome"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Cancelar
              </v-btn>

              <v-btn color="blue darken-1" text @click="save"> Salvar </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <authorization
        permissionKey="configuration_prosthesis"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="editItem(item)">
          eva-edit-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_prosthesis"
        can="delete"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small @click="deleteItem(item)">
          eva-trash-outline
        </v-icon>
      </authorization>
    </template>

    <template v-slot:no-data>
      <v-alert color="orange" outlined text type="info">
        Não há modelos cadastradas
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "ProsthesisTypeConfig",
  apollo: {
    prosthesisTypes: {
      query: require("@/graphql/prosthesis/prosthesis_types.gql"),
      pollInterval: 20000,
    },
  },
  data() {
    return {
      dialog: null,
      editedItem: {},
      editedIndex: -1,
      filter: "",
      headers: [
        { text: "Nome", value: "name" },
        { text: "Ações", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  computed: {
    filteredProsthesisTypes() {
      let prosthesisTypes = this.prosthesisTypes;

      if (this.filter) {
        prosthesisTypes = this.lodash.filter(
          prosthesisTypes,
          function (e) {
            return e.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .includes(
                this.filter
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
              );
          }.bind(this)
        );
      }

      return prosthesisTypes;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nova modelo" : "Editar modelo";
    },
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.filteredProsthesisTypes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      if (confirm("Você realmente deseja deletar esse modelo?")) {
        this.apolloMutate({
          mutation: require("@/graphql/prosthesis/delete_prosthesis_prosthesis_type.gql"),
          variables: {
            prosthesisTypeId: item.id,
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Modelo deletado com sucesso.",
            type: "success",
          });
        });
      }
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save() {
      this.apolloMutate({
        mutation: require("@/graphql/prosthesis/save_prosthesis_prosthesis_type.gql"),
        variables: {
          prosthesisTypeId: this.lodash.get(this.editedItem, "id", ""),
          name: this.editedItem.name,
        },
      }).then(() => {
        this.refreshList();

        this.$store.dispatch("createNotification", {
          message: "Cadastro salvo com sucesso.",
          type: "success",
        });
      });

      this.close();
    },
    refreshList() {
      return this.$apollo.queries.prosthesisTypes.refetch();
    },
  },
};
</script>

<style lang="scss" scoped></style>
